import qs from 'qs';

/**
 * @description
 * custom Hook function to extract query string from url.
 * @param {string} query - Url query string.
 * @returns {Object} Object with parsed query string.
 */
const customParse = query =>
  qs.parse(query, {
    decoder(str, decoder, charset) {
      const strWithoutPlus = str.replace(/\+/g, ' ');
      if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
      }

      const keywords = {
        true: true,
        false: false,
        null: null,
        undefined,
      };
      if (str in keywords) {
        return keywords[str];
      }

      // utf-8
      try {
        return decodeURIComponent(strWithoutPlus);
      } catch (e) {
        return strWithoutPlus;
      }
    },
  });

/**
 * @description
 * custom Hook function to extract query string from url.
 * @param {Object} history - Object.
 * @returns {Object} Object with parsed query string.
 */
export function getQueryString(history) {
  const query = history.location.search.substring(
    1,
    history.location.search.length,
  );
  return customParse(query);
}

export default {
  parse: customParse,
  stringify: qs.stringify,
};
